import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography, useThemeValue } from '@altermaind/web/ui';
import { BlockingDialog } from '@/_shared/components/BlockingDialog';
import { convertColorToRgba } from '@/_shared/helpers/convertColorToRgba';
import { useDialog } from '@/_shared/hooks';
import type { DialogContactsPayload } from '@/core/components/DialogContacts/DialogContacts';
import { getUserAuthorizeCall } from '@/core/state/api/getUserAuthorizeCall';
import { useLogin } from '@/login/state';
import { UserAuthErrorType } from '@/swagger/constants/slash-enums';

export const DialogSubscriptionBetaExpired: FC = () => {
  const t = useTranslations('billing.dialogSubscriptionBetaExpired');
  const { blockingErrorType } = getUserAuthorizeCall.hook();
  const { openDialog: openContacts } = useDialog<DialogContactsPayload>('contacts');
  const { logout } = useLogin();
  const errorBg = useThemeValue('colors', 'background/error');

  const isOpen = blockingErrorType === UserAuthErrorType.SUBSCRIPTION_BETA_EXPIRED;

  return (
    <BlockingDialog
      name='subscriptionBetaExpired'
      open={isOpen}
      dialogProps={{ maxWidth: '900px' }}
    >
      <Box
        display='flex'
        mb='m'
        flexDirection='column'
        alignItems='center'
        alignSelf='center'
        bg={errorBg ? (convertColorToRgba(errorBg, 0.1) as never) : 'background/error'}
        p='xs'
        borderRadius='100%'
      >
        <Svg name='warning' size='xxl' stroke='error' />
      </Box>
      <Typography variant='h3' mt='none' textAlign='center' mb='s' color='primary/text'>
        {t('title')}
      </Typography>
      <Typography
        variant='p2/light'
        textAlign='center'
        mb='l'
        color='grey/light'
        style={{ whiteSpace: 'pre-line' }}
      >
        {t('description')}
      </Typography>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <Button variant='primary' onClick={() => openContacts({})}>
          {t('contactUs')}
        </Button>
        <Button variant='link/primary' mt='s' onClick={logout}>
          {t('logout')}
        </Button>
      </Box>
    </BlockingDialog>
  );
};
